import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a8c45ebc&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=a8c45ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c45ebc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8c45ebc')) {
      api.createRecord('a8c45ebc', component.options)
    } else {
      api.reload('a8c45ebc', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=a8c45ebc&scoped=true&", function () {
      api.rerender('a8c45ebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/suggestQuery/detail.vue"
export default component.exports